module.exports = __webpack_public_path__ + "img/Hero@2x.0ea2a1c6.png";